// extracted by mini-css-extract-plugin
module.exports = {"sliderArrow":"SliderArrow_sliderArrow__IsRjA","right":"SliderArrow_right__T5Rvm","left":"SliderArrow_left__mJqTa"};